import React from "react";
import { cn } from "../../utils/cn";

const Label = React.forwardRef(({ 
  className,
  htmlFor,
  children,
  required = false,
  error = false,
  ...props 
}, ref) => {
  return (
    <label
      ref={ref}
      htmlFor={htmlFor}
      className={cn(
        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        error ? "text-destructive" : "text-foreground",
        className
      )}
      {...props}
    >
      {children}
      {required && <span className="text-destructive ml-1">*</span>}
    </label>
  );
});

Label.displayName = "Label";

export default Label;